<style lang="css">

</style>

<template lang="html">

<el-row :gutter="20">

  <el-col :span="12" >
    <el-card style="min-height:630px;">
      <user-browse-record-detail></user-browse-record-detail>
    </el-card>
  </el-col>
  <el-col :span="12" >
    <el-card style="min-height:630px;">
      <user-coin-detail></user-coin-detail>
    </el-card>
  </el-col>

  <el-col :span="12" style="margin-top:10px;">
    <el-card style="min-height:630px;">
      <el-table :data="datas" style="width: 100%">
          <el-table-column prop="nickname" label="昵称">
          </el-table-column>
          <el-table-column prop="badFlag" label="风险检测">
          </el-table-column>
          <el-table-column min-width="90px" prop="phone" label="手机号">
          </el-table-column>
          <el-table-column prop="isBind" label="是否绑定">
          </el-table-column>
          <el-table-column prop="coinTotalCount" label="收入/提现">
            <template scope="scope">
              {{scope.row.coinTotalCount}} / {{scope.row.coinConsumeCout}}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" show-overflow-tooltip label="创建时间">
          </el-table-column>
      </el-table>
      <el-pagination style="margin-top:10px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </el-col>
  <el-col :span="12" style="margin-top:10px;">

    <el-card style="min-height:630px;">
      <el-row>
        <p>{{withdrawCashInfo.nickname}} {{withdrawCashInfo.personPhone}}</p>
        <p>申请时间：{{withdrawCashInfo.createTime | dateTimeFormat}}</p>
        <p>注册时间：{{withdrawCashInfo.lcwUserCreateTime | dateTimeFormat}}</p>
        <p>最后活跃：{{withdrawCashInfo.loginTime | dateTimeFormat}}</p>
        <p>风险评测：{{withdrawCashInfo.badFlag}}</p>
        <p>用户来源：{{withdrawCashInfo.channelName?withdrawCashInfo.channelName:'暂无'}}</p>
        <p>当前提现金额：{{withdrawCashInfo.money}} 元</p>
        <p>审核状态：{{withdrawCashInfo.status | coinWithdrawCashFilter}}</p>
        <p>累计提现金额：{{withdrawCashInfo.convertMoney}} 元</p>
      </el-row>
      <hr/>
      <el-row>
        <el-button round @click="showAuditStatusDialog(4)" size="mini" type="info">暂缓</el-button>
        <el-button round @click="showAuditStatusDialog(2)" size="mini" type="primary">通过</el-button>
        <el-button round @click="showAuditStatusDialog(3)" size="mini" type="warning">不通过</el-button>
        <el-button round @click="showAuditStatusDialog(5)" size="mini" type="warning">异常</el-button>
      </el-row>

    </el-card>
  </el-col>
</el-row>

</template>

<script>
import userBrowseRecordDetail from './userBrowseRecordDetail'
import userCoinDetail from './userCoinDetail'
import coinModel from '@/framework/models/coinModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'user-invite-detail',
  components: {
    userBrowseRecordDetail,
    userCoinDetail
  },
  extends: BasicPager,
  data: function () {
    return {
      id: null,
      pageNum: 1,
      pageSize: 10,
      datas: [],
      total: 0,
      withdrawCashId: null,
      withdrawCashInfo: {}
    }
  },
  created: function () {
    let params = this.$route.params
    this.id = params.id
    this.withdrawCashId = params.withdrawCashId
    this.loadList()
    if (this.withdrawCashId) {
      this.loadWithdrawCashInfo()
    }
  },
  methods: {
    loadWithdrawCashInfo: function () {
      let _this = this
      let params = {
        id: this.withdrawCashId
      }
      let listener = {
        success: function (dataInfo) {
          _this.withdrawCashInfo = dataInfo.datas
        }
      }
      coinModel.selectWithdrawMoneyRecordInfo(_this, params, listener)
    },
    showAuditStatusDialog: function (auditStatus) {
      this.$confirm('请确认你的审核操作是否无误？', '提现审核后不能逆转，请二次确认！', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.changeAuditStatus(this.withdrawCashId, auditStatus)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    changeAuditStatus: function (id, auditStatus) {
      let _this = this
      let params = {
        id: id,
        auditStatus: auditStatus,
        employeeId: this.loginInfo.employeeId,
        employeeName: this.loginInfo.realName
      }

      let listener = {
        success: function (dataInfo) {
          _this.$message({
            message: '操作成功！',
            type: 'success'
          })
          _this.$router.back(-1)
        }
      }
      coinModel.changeAuditStatus(_this, params, listener)
    },
    handleCurrentChange: function (pageNum) {
      this.pageNum = pageNum
      this.loadList()
    },
    handleSizeChange: function (pageSize) {
      this.pageSize = pageSize
      this.pageNum = 1
      this.loadList()
    },
    loadList: function () {
      let _this = this
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        lcwUserId: this.id
      }
      let listener = {
        success: function (dataInfo) {
          _this.datas = dataInfo.datas.data
          _this.total = dataInfo.datas.recordsTotal
        }
      }

      coinModel.findUserInviteDetail(_this, params, listener)
    }
  }
}

</script>
